import "./App.css";
import { Route, Routes } from "react-router-dom";
import Header from "./components/common/Header/Header";
import Home from "./components/pages/Home/Home";
import Footer from "./components/common/Footer/Footer";
import Login from "./components/pages/Login/Login";
import Singup from "./components/pages/Login/SignUp/SignUp";
import { useAuthState } from "react-firebase-hooks/auth";
import { auth } from "./firebase.init";
import AddProduct from "./components/pages/Home/ProductSection/AddProduct/AddProduct";
import SingPageDetails from "./components/pages/Home/ProductSection/SingleProuctDetails/SingPageDetails";
import NotFound from "./components/pages/NotFound/NotFound";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AllProduct from "./components/pages/Home/ProductSection/AllProduct/AllProduct";
import RequireAuth from "./components/pages/Login/RequireAuth";
import MyProduct from "./components/pages/Home/ProductSection/MyProduct/MyProduct";
import ProductEdit from "./components/pages/Home/ProductSection/ProductEdit/ProductEdit";
import ForgetPassword from "./components/pages/Login/ForgetPassword/ForgetPassword";
import Blog from "./components/pages/Blog/Blog";

function App() {
  return (
    <>
      <Header></Header>
      <Routes>
        <Route path="/" element={<Home></Home>}></Route>
        <Route path="/blog" element={<Blog></Blog>}></Route>

        <Route
          path="/product/:id"
          element={<SingPageDetails></SingPageDetails>}
        ></Route>
        <Route
          path="/product/edit/:id"
          element={
            <RequireAuth>
              <ProductEdit></ProductEdit>
            </RequireAuth>
          }
        ></Route>
        <Route
          path="/all-products"
          element={
            <RequireAuth>
              <AllProduct></AllProduct>
            </RequireAuth>
          }
        ></Route>
        <Route
          path="/add-product"
          element={
            <RequireAuth>
              <AddProduct></AddProduct>
            </RequireAuth>
          }
        ></Route>

        <Route
          path="/my-item"
          element={
            <RequireAuth>
              <MyProduct></MyProduct>
            </RequireAuth>
          }
        ></Route>
        
        <Route path="/forget-password" element={<ForgetPassword />}></Route>
        <Route path="/login" element={<Login></Login>}></Route>
        <Route path="/signup" element={<Singup></Singup>}></Route>
        <Route path="*" element={<NotFound></NotFound>}></Route>
      </Routes>

      <Footer></Footer>
      <ToastContainer />
    </>
  );
}

export default App;
